import React from 'react';
import StringProcessingService from '../../services/string-processing-service';
import {Link} from 'react-router-dom';
import './neighborhood-item-style.css'
class NeighborhoodsItem extends React.Component {
    stringProcessingService = new StringProcessingService();

    renderBody() {
        if (this.props.data!==undefined) {
            let {data,slider=false} = this.props;
            return (
                    <Link to={`/neighborhood/${data.id}/${this.stringProcessingService.StringFormatUrl(data.name)}`}>
                        <div className="NeighboorSliderItem" id = {!slider?"NeighboorGridItem":""}>
                            <div className="Overlay"></div>
                            <img src={`https://ngirealty.com/img/smart_luxe/areas/thumbs/${data.image_thumb}`} alt=""></img>
                            <div>{data.name}</div>
                        </div>
                    </Link>
            )

        }
    }
    render() {
        return (
            <>
                {this.renderBody()}
            </>
        );
    }
}
export default NeighborhoodsItem;